import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { WebModal } from '@components/Modals/WebModal.web';
import { Box, Text } from '@components/Restyle';
import { Spinner } from '@components/shared/Spinner';
import theme from '@themes/theme';

interface WebModalComponentProps {
  title?: string;
  modalWidth: number;
  modalHeight?: number;
  xVisible: boolean;
  msgBody: string;
  okButtonTitle: string;
  onCloseModal: () => void;
  onPressOK: () => void;
  isLoading?: boolean;
}

const WebModalComponent: React.FC<WebModalComponentProps> = ({
  title,
  modalWidth,
  modalHeight,
  xVisible,
  msgBody,
  okButtonTitle,
  onCloseModal,
  onPressOK,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <WebModal
      accessibilityLabel={title || t('models:teams.leave.title')}
      visible={xVisible}
      width={modalWidth}
      height={modalHeight}
      title={title || t('models:teams.leave.title')}
      titleVariant='labelLarge'
      titleColor='textSecondary'
      marginTop='m'
      marginHorizontal='l'
      closeDisabled={isLoading}
      onClose={onCloseModal}>
      <Box flex={1} mt='l' mx='l'>
        <Text variant='webBodySecondary' color='black'>
          {msgBody}
        </Text>
        <Box
          mt='l'
          mb='m'
          flexDirection='row'
          alignItems='flex-end'
          justifyContent='flex-end'>
          <TouchableOpacity
            disabled={isLoading}
            onPress={isLoading ? undefined : onCloseModal}>
            <Box
              height={56}
              justifyContent='center'
              alignContent='center'
              alignItems='center'
              accessibilityLabel={t('models:teams.removeTeamMember.assign')}>
              <Text
                variant='typography'
                color={isLoading ? 'grey04' : 'textPrimary'}
                mr='l'>
                {t('shared:cancel')}
              </Text>
            </Box>
          </TouchableOpacity>

          <TouchableOpacity
            disabled={isLoading}
            onPress={isLoading ? undefined : onPressOK}>
            <Box
              backgroundColor='black'
              borderRadius='xs'
              width={100}
              height={56}
              justifyContent='center'
              alignContent='center'
              alignItems='center'
              accessibilityLabel={okButtonTitle}>
              <Box position='relative' width='100%' alignItems='center'>
                {isLoading && (
                  <Box
                    testID='web-modal-component-spinner'
                    position='absolute'
                    top={0}
                    bottom={0}
                    left={0}
                    right={0}
                    alignItems='center'
                    justifyContent='center'>
                    <Spinner
                      size={16}
                      strokeWidth={2}
                      color={theme.colors.white}
                    />
                  </Box>
                )}
                <Text
                  variant='typography'
                  color='white'
                  style={{ opacity: isLoading ? 0 : 1 }}>
                  {okButtonTitle}
                </Text>
              </Box>
            </Box>
          </TouchableOpacity>
        </Box>
      </Box>
    </WebModal>
  );
};

export default WebModalComponent;
